module.exports = __webpack_public_path__ + "static/media/gruenenwald_adrienne.7d190d41.mp3";